import React from 'react';

import { RouteInterface } from 'routes';
import GenericListRoute from 'routes/generic/list';

import { DenormalizedSchedule } from 'store/data';

interface Props {
  routes: RouteInterface[];
}

const List: React.FC<Props> = ({ routes }) => {
  return (
    <GenericListRoute<DenormalizedSchedule>
      resolver="schedules"
      itemName="schedule"
      listItemTitle={entity => entity.identifier}
      listTitle="Schedules"
      detailRoute="schedule"
      detailIdParam="scheduleId"
      createRoute="schedules:create"
      dependencies={[]}
      routes={routes}
      showListTitle={true}
    />
  );
};

export default List;
